import { createLoginApi, type LoginApi } from "@tucan/login";
import { getPublicEnv } from "@tucan/utils";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

/**
 * Browser client of the login routes (`/api/auth/*`, below `NEXT_PUBLIC_ENDPOINT` like every
 * route `useApiProxy` calls). Emails the API sends use the current language.
 */
export const useLoginApi = (): LoginApi => {
  const { i18n } = useTranslation();

  return useMemo(
    () =>
      createLoginApi({
        basePath: `${getPublicEnv("ENDPOINT")}/auth`,
        language: i18n.language,
      }),
    [i18n.language],
  );
};
